export const INFORMATION = "INFORMATION";
export const OPENING_TIMES = "OPENING TIMES";
export const ADDRESS_OPTIONAL = "OPTIONAL ADDRESS";
